
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as switchnREKK_45l5wgbENMuiP8nOcNmFxW4cvUaucq3eesIFeoMMeta } from "/vercel/path0/volunteerly/pages/switch.vue?macro=true";
import { default as formsmhahOJkXWU5tNtmHHZDQy88UL1y7lOPCRNBlxKkf8LMMeta } from "/vercel/path0/base/pages/content/forms.vue?macro=true";
import { default as indexbgvkUgrfpp1hz54kuB2NdEwohL3tYf6b2RLjRseCl_45YMeta } from "/vercel/path0/base/pages/content/index.vue?macro=true";
import { default as menu_45itemsbqZ8vse8wlIQvyz2xn9nanWYZq5Z_456t_yXGuKtH0BJcMeta } from "/vercel/path0/base/pages/content/menu-items.vue?macro=true";
import { default as file_45uploadpywHBDu3oeT39VEinTINs4P_45IAnoY1iPbt9sxFYcqicMeta } from "/vercel/path0/base/pages/content/file-upload.vue?macro=true";
import { default as stock_45imagesw_45jl30K9AjVbDBThUIwieGmX2nref96jIRW5pTjyQMMMeta } from "/vercel/path0/base/pages/content/stock-images.vue?macro=true";
import { default as contentGXWpq9tObVjjFJHyj9D9ioI8pM1x9vl6ViUxlnroHdMMeta } from "/vercel/path0/base/pages/content.vue?macro=true";
import { default as _91_91slug_93_93QsK4XG8M4jXI1MXEDlD7KmTbHy2GYd3IBbZ4yPxAa7YMeta } from "/vercel/path0/base/pages/[[slug]].vue?macro=true";
import { default as partnersfNjqDY_45glohiyHaI45rG4Wr_vGNwESn4uIMb9GYoXOUMeta } from "/vercel/path0/volunteerly/pages/partners.vue?macro=true";
import { default as apiSOdkRnbISCaAkoRAqOfKP32OwBIPnyaGjuCwC9uDM0cMeta } from "/vercel/path0/volunteerly/pages/test/api.vue?macro=true";
import { default as authM6xkMaERq0O0C1h9tZiOQcluo_45wwE4pXcHhyjBKq_iQMeta } from "/vercel/path0/base/pages/test/auth.vue?macro=true";
import { default as dupeesfwdPNhguiksYpsbsUNSORkFpYL30oLLcYPc9ZH8uwMeta } from "/vercel/path0/base/pages/test/dupe.vue?macro=true";
import { default as form2Et0Ex1WDnn1LQOzNPPcUaGcF7_45LiF2eHaPWUbkrjwIMeta } from "/vercel/path0/base/pages/test/form.vue?macro=true";
import { default as usergP1j2ugkOOTjfIOTEE84Z4_I0BzGtfGwgtoQkc7whosMeta } from "/vercel/path0/base/pages/test/user.vue?macro=true";
import { default as uitloggenRZCPzRvLi_45FWyxUwAogNzfeERw_JHTQ2DjzbWesid8sMeta } from "/vercel/path0/base/pages/uitloggen.vue?macro=true";
import { default as addtCvDip_45gr_RHXHHnVup4604_45OGSrQgt9rSwO0VvjptcMeta } from "/vercel/path0/base/pages/users/add.vue?macro=true";
import { default as reset78Ka2XQeSD_Mqmo_45L0NKLVjPtxjgEJykMea_cq2GcswMeta } from "/vercel/path0/base/pages/auth/reset.vue?macro=true";
import { default as tokenNvAQPDX2cOrVU3WRWm_45UAU_45Tqvl6M9XYQ3YtXd_hh2QMeta } from "/vercel/path0/base/pages/auth/token.vue?macro=true";
import { default as colorsCnrXXnlfUQs9MGmkYVaPZ7oKt3LHVe9RpSN87tAw3bwMeta } from "/vercel/path0/base/pages/test/colors.vue?macro=true";
import { default as sentryfO_83x5yZMymiL_45F6SQoM_45_0iDolX_45zg7eJwJDy6leYMeta } from "/vercel/path0/base/pages/test/sentry.vue?macro=true";
import { default as tiptapZF_z2fZEAOqMye0sS6vh8NgZkNfnQaw3_45NLG7_aUKuYMeta } from "/vercel/path0/base/pages/test/tiptap.vue?macro=true";
import { default as indexFukoIn_459388Jem9pfucq_457ZATztFhwjpo17oQaef_45ToMeta } from "/vercel/path0/base/pages/users/index.vue?macro=true";
import { default as login_451OezAPgOU8OgIsqyIsj0rIcnrmiegfAWEU7y5OhX0Xy4Meta } from "/vercel/path0/base/pages/auth/login-1.vue?macro=true";
import { default as recoverKAswSXY0F54QD5SJTFd1JgQTo9zF7PIqylCuE7vRqdoMeta } from "/vercel/path0/base/pages/auth/recover.vue?macro=true";
import { default as indexoAE8nGoW2Mzb6winsSTDHEnX8KXGs5aoLLGWl_45WCs8IMeta } from "/vercel/path0/volunteerly/pages/instellingen/index.vue?macro=true";
import { default as designsVq4qQTl9oWSCvihMtCZd4RO9yW_1GY24TZfwZWtjMkMeta } from "/vercel/path0/volunteerly/pages/instellingen/design.vue?macro=true";
import { default as footerQt7rKB6idK2U6pXLNtf5qEMs7ZiJafjsQfVo1_JzTMYMeta } from "/vercel/path0/volunteerly/pages/instellingen/footer.vue?macro=true";
import { default as organisatieN8feCOT_iPD2lpJ_45cyqo2zMoGh0HkMfd6_45n9Hrq9O_MMeta } from "/vercel/path0/base/pages/instellingen/organisatie.vue?macro=true";
import { default as contact_45persongc9ERVQCHfD3cOmosZ2fmpEnZ6WHVlr4G2hFvdztu08Meta } from "/vercel/path0/volunteerly/pages/instellingen/contact-person.vue?macro=true";
import { default as instellingen5uDB5fDtgAITgRtmA5VPULm2bUfJOS_45EqOO31j3fld8Meta } from "/vercel/path0/volunteerly/pages/instellingen.vue?macro=true";
import { default as emailYzFfIkp4CC4D2XW1xSpPu3w9_fxeoNx0aL1RA_OdqmgMeta } from "/vercel/path0/base/pages/profile-edit/email.vue?macro=true";
import { default as indexdHpWA80Jy0Ejgk_4503vt5GVgkt_45jGiOU2nhz_45ESrORWYMeta } from "/vercel/path0/volunteerly/pages/profile-edit/index.vue?macro=true";
import { default as settings9KYisyRo2PMIyO3Jp18T_45xk0BRll6i8KO0JK1In1g_45sMeta } from "/vercel/path0/base/pages/profile-edit/settings.vue?macro=true";
import { default as periodieke_45maild6nSl4UYxMtQDEubXVQAyDUkngVcNc3xSrLrydPtKq0Meta } from "/vercel/path0/base/pages/profile-edit/periodieke-mail.vue?macro=true";
import { default as profile_45editfJHqxD9pjopzAWMddQFTUyFlSqGdMh9SStSTdLx5xFsMeta } from "/vercel/path0/base/pages/profile-edit.vue?macro=true";
import { default as indexAHmqB2DQypbdtg0N67Fmn1x5URPgRY5d_45Vs_45iIpOcYgMeta } from "/vercel/path0/volunteerly/pages/signup/index.vue?macro=true";
import { default as toasterRFh4AGluamyVxdStjoNnnWCr7HG4iMayusXlEgITz4oMeta } from "/vercel/path0/base/pages/test/toaster.vue?macro=true";
import { default as rolesjR_xG6ru98QGFtHOE5uNZyks_4AV1uG7n4jsqkyLh_45EMeta } from "/vercel/path0/base/pages/account/roles.vue?macro=true";
import { default as indexJ542y_0elABrCYz1UPobUSRF8cO5KIJnqcqThFfj9YgMeta } from "/vercel/path0/base/pages/confirm/index.vue?macro=true";
import { default as index_45zp2pAkguCIA_ZgTzu6hbrvxbuwLVJLJakvXPqk4r6YMeta } from "/vercel/path0/volunteerly/pages/profiel/index.vue?macro=true";
import { default as addohbZOBAjc_45ezzCy_RLQM2an4ByOzXvhzaC2I49c5L2kMeta } from "/vercel/path0/volunteerly/pages/vacancies/add.vue?macro=true";
import { default as successNLioIIDxkpBSfXdTCyoBKz_Gha1STEh1Ze8qdotLl2YMeta } from "/vercel/path0/volunteerly/pages/signup/success.vue?macro=true";
import { default as step_45form0sFaJXtv4qVuYIcDrQUKg9D_aXR5Wiqry7UBZ1HMBgMMeta } from "/vercel/path0/base/pages/test/step-form.vue?macro=true";
import { default as index4G1ApQYCnbWmPdCqsKuhBxNOGqXd9GCpl1HjPahe9ucMeta } from "/vercel/path0/base/pages/analytics/index.vue?macro=true";
import { default as indexEAlTld7ZnQkKIWiUbtHqnFfE_45jagyGjdxa36WFtVLPYMeta } from "/vercel/path0/volunteerly/pages/dashboard/index.vue?macro=true";
import { default as een_45op_45een_45hulpslWHx8s3ngAGg1PeLzkuL_vNKa0oD65075CKPIQozu4Meta } from "/vercel/path0/volunteerly/pages/een-op-een-hulp.vue?macro=true";
import { default as _91_91token_93_93G_fI772El8Xn6zqIzr4sJkhuvp_QvgJUfatVtOy9yb4Meta } from "/vercel/path0/base/pages/forms/[[token]].vue?macro=true";
import { default as gelderse_45handenuCb6tdtLV3kfR4cR6UZe5MLPyjqh0ueACeicPIH5f5wMeta } from "/vercel/path0/volunteerly/pages/gelderse-handen.vue?macro=true";
import { default as _91_91slug_93_9347z5XE5NpXFKxdK0utfxGJTDXP3zggcWqBpUSy9VcpwMeta } from "/vercel/path0/base/pages/nieuws/[[slug]].vue?macro=true";
import { default as datepickerZ9Uc62dayGHTsUBHzNt0voknTbZhe3CWBn9nj9du43MMeta } from "/vercel/path0/base/pages/test/datepicker.vue?macro=true";
import { default as dollar_45apiIa2f9nAr1o32iJ29QvjJwJfHyUrO0_45TKzMVwf72K2SQMeta } from "/vercel/path0/base/pages/test/dollar-api.vue?macro=true";
import { default as user_45store4FnBzCqI24BmXAxOulaUczgQeM3CjoETp4UyHZQxC9sMeta } from "/vercel/path0/base/pages/test/user-store.vue?macro=true";
import { default as editMot6_45mVQAK_jppiwXXjh1s9CkUw0g50YZKmdRJZTy9kMeta } from "/vercel/path0/base/pages/users/[id]/edit.vue?macro=true";
import { default as indexB8A_450R15q01Jz6f01GYl9rzKQtBMy_455_eEaIUA9M_45vIMeta } from "/vercel/path0/volunteerly/pages/vacancies/index.vue?macro=true";
import { default as index61eiIHJVSHkxJA7nKw5kdfGs7DaO241eKlhJwIlGk0IMeta } from "/vercel/path0/volunteerly/pages/workshops/index.vue?macro=true";
import { default as contactformulieryD3Wg7Q5zrL5hcuadXrB5u8lnNY_6hxEl4ElQTSolY0Meta } from "/vercel/path0/base/pages/contactformulier.vue?macro=true";
import { default as newTF4aWIMC7UwzPUIPz7m019M8x6agtLXN7wFWAEjJtQMMeta } from "/vercel/path0/base/pages/form_builder/new.vue?macro=true";
import { default as formbuilderFB8mzKtmWNnO419Q_x6hZMAeJXMsDD4Q4U4zagmNLF8Meta } from "/vercel/path0/base/pages/test/formbuilder.vue?macro=true";
import { default as step_45form_4526n2AjG9VA3pWcZQqrZyGThp2YaVjfjAzAiU1TqY2XSEMeta } from "/vercel/path0/base/pages/test/step-form-2.vue?macro=true";
import { default as indexT_slu_RCDKnUixR51nzwuouyGgy_vK8OWtFFllsBlssMeta } from "/vercel/path0/base/pages/users/[id]/index.vue?macro=true";
import { default as data_45viewer8J56mPL73EkedxoU97Vx3K4DoF5yjY8YiLc_459Mrbo8cMeta } from "/vercel/path0/base/pages/admin/data-viewer.vue?macro=true";
import { default as index_452Nt_45xlu3NU_45YYWUoHxdcuG29Wwtj0eHymtB6oHzq30aMMeta } from "/vercel/path0/base/pages/analytics/index-2.vue?macro=true";
import { default as addo_7hfh3vOT0j6i3YMUIN66ag_45JOIXCo6YNci5VasALQMeta } from "/vercel/path0/volunteerly/pages/organizations/add.vue?macro=true";
import { default as server_45errorCK7Dj7WFlafDQZYt4eOA0yJozYbX1b0D89CMmgFmwrQMeta } from "/vercel/path0/base/pages/test/server-error.vue?macro=true";
import { default as index_45vNKSYB_45kTUKwlX1F74QK2pZP8WJ44w5I4nzN9USPCwMeta } from "/vercel/path0/volunteerly/pages/applications/index.vue?macro=true";
import { default as indexsK6RIfMh7qu6ZxVm02G5hu6PLO2RXPHhwaL8WBLITmYMeta } from "/vercel/path0/base/pages/form_builder/index.vue?macro=true";
import { default as indexcB3aCEMLIlH7_45SklrjPvOEqadJKIKxCMAMaHQFdFDS0Meta } from "/vercel/path0/base/pages/notificaties/index.vue?macro=true";
import { default as verwijderdTJWt7UiBCW3mKMy6yMHphZHBODbbYomui3No7ipiJl8Meta } from "/vercel/path0/volunteerly/pages/profiel/verwijderd.vue?macro=true";
import { default as _91id_93MtUYzBLXATGxg6ubBtRh19KuMXYY_cmHOQ7PTyKxX40Meta } from "/vercel/path0/volunteerly/pages/sociale-kaart/[id].vue?macro=true";
import { default as verwijderenkam4Fk_45d9q24mjZqvJYiU4h3LUZkMlI6y_ThjDOC4RQMeta } from "/vercel/path0/base/pages/account/verwijderen.vue?macro=true";
import { default as indexOXPxkrtf5v6uLwHlvDwQH3GIGNKBsz7t1aFGhyDC9R4Meta } from "/vercel/path0/volunteerly/pages/conversations/index.vue?macro=true";
import { default as indexV_jCA70IDgr5KTBZX3B00xkar55FBsa8fCKAfO0WDwMMeta } from "/vercel/path0/volunteerly/pages/organizations/index.vue?macro=true";
import { default as indexdb2QOxwmCd1ShI9dREFbgLGVS15MT_45R7sQ3GsRbZJY8Meta } from "/vercel/path0/volunteerly/pages/sociale-kaart/index.vue?macro=true";
import { default as add_roleuzkNVv8IQYd2C1r_45rqzdpaB2jJln_OKQJ9EuIh0HFqUMeta } from "/vercel/path0/base/pages/users/[id]/add_role.vue?macro=true";
import { default as editcxnjP_sCQFJd_45Cz11aH7sNqpynI8bQIrYbf_45OM3csEUMeta } from "/vercel/path0/volunteerly/pages/vacancies/[id]/edit.vue?macro=true";
import { default as bulk_45editmb0EBwUeKVGrD0M1huqRjOujxe4yRz48vVMCzMfwRsMMeta } from "/vercel/path0/volunteerly/pages/vacancies/bulk-edit.vue?macro=true";
import { default as index4_acO5hAi_45BYkhCgIWkYU61nNHKdqUxa3aZIwQtcLOsMeta } from "/vercel/path0/volunteerly/pages/vacancies/[id]/index.vue?macro=true";
import { default as approvegsFoIYYYfcySXX7yDJT0cep6HfwIRZLaFGSrgFwZEq0Meta } from "/vercel/path0/volunteerly/pages/organizations/approve.vue?macro=true";
import { default as index6yyOorsXjqbrCqsTIT4dYlDRTJrY_OxtZ_45AXKZRlGzgMeta } from "/vercel/path0/volunteerly/pages/profile-replies/index.vue?macro=true";
import { default as changelogL36YcMCe59TaL6l90GrQqh_45294yxcgjb_454HXoeCUjb4Meta } from "/vercel/path0/volunteerly/pages/volunteerly/changelog.vue?macro=true";
import { default as edit0Pr0HV_LAodzT6B_45bVp919fKgibis1w35d1Nucqojb0Meta } from "/vercel/path0/base/pages/form_builder/[id]/edit.vue?macro=true";
import { default as indexnQj3kTeDJKm1KVH1SgUwZuEww_45J4Dy9b4lwMMHwFIOMMeta } from "/vercel/path0/volunteerly/pages/vacancies/search/index.vue?macro=true";
import { default as indexiLd2IWbR8xws4EHboOWJrSfrFyHyHYEDOf6IdxrArjsMeta } from "/vercel/path0/volunteerly/pages/applications/[id]/index.vue?macro=true";
import { default as index1f5TxqNJoO2uL2ZrAWJ4ne8mbSvbV0R0Hr_45Si_453QLpkMeta } from "/vercel/path0/base/pages/form_builder/[id]/index.vue?macro=true";
import { default as edit69JHImuJR7YgME9_t1WRpulwsEcugGl0y9_DTI5XsTQMeta } from "/vercel/path0/volunteerly/pages/organizations/[id]/edit.vue?macro=true";
import { default as move2O6dA6t1wNsQ6kOSKGyvklbp2YdD_45lHqSdkX0FQyO1gMeta } from "/vercel/path0/volunteerly/pages/organizations/[id]/move.vue?macro=true";
import { default as indexj01EHSRyX71OAOs_45aKE2tCbmVF3UvrJZFxMDTmBtrhsMeta } from "/vercel/path0/volunteerly/pages/vrijwilligerspool/index.vue?macro=true";
import { default as indexN9mA75OPwKgGV7D4Y4t6E5PEpLrJggpxCiuUWWo39PYMeta } from "/vercel/path0/volunteerly/pages/organizations/[id]/index.vue?macro=true";
import { default as previewzJ0_bAMCxPOftZU5QXIKin_BhFbsfCTai5bt32or6dAMeta } from "/vercel/path0/base/pages/form_builder/[id]/preview.vue?macro=true";
import { default as index0dIVMUrneLyWt378e_h0FUBtX8UuVUaDo4x2SycsFqMMeta } from "/vercel/path0/volunteerly/pages/activiteitenkalender/index.vue?macro=true";
import { default as index0HhoILaZz6o2rG3kufdTemM1_45wbGDXqv2JtpDJnuQ28Meta } from "/vercel/path0/volunteerly/pages/organizations/signup/index.vue?macro=true";
import { default as indexWKLClckes_45wQO54qEDyHJTIboCDlEbgtVyuojEDWpA8Meta } from "/vercel/path0/base/pages/notification_templates/index.vue?macro=true";
import { default as successXVwnruZ10l93HoRJl_45KH_QfUD4ewe7RE0GCQQIFBvDcMeta } from "/vercel/path0/volunteerly/pages/organizations/signup/success.vue?macro=true";
import { default as overzicht9pYpW_mwaQx6a4Zgj1sSO2b4nvDc1nNML2BK_45JeBFvYMeta } from "/vercel/path0/volunteerly/pages/activiteitenkalender/overzicht.vue?macro=true";
import { default as editzmFIwmFQVKWfhmyEKZUvARa0TDS0fFcKhel6NXGvNZkMeta } from "/vercel/path0/base/pages/notification_templates/[id]/edit.vue?macro=true";
import { default as _91submissionId_93YKP_45sk1pybLI0a3yJdawfbcL_0uCjvPTTbnXd7cew14Meta } from "/vercel/path0/base/pages/form_builder/[id]/submissions/[submissionId].vue?macro=true";
export default [
  {
    name: "switch",
    path: "/switch",
    meta: switchnREKK_45l5wgbENMuiP8nOcNmFxW4cvUaucq3eesIFeoMMeta || {},
    component: () => import("/vercel/path0/volunteerly/pages/switch.vue")
  },
  {
    name: contentGXWpq9tObVjjFJHyj9D9ioI8pM1x9vl6ViUxlnroHdMMeta?.name,
    path: "/content",
    component: () => import("/vercel/path0/base/pages/content.vue"),
    children: [
  {
    name: "content-forms",
    path: "forms",
    component: () => import("/vercel/path0/base/pages/content/forms.vue")
  },
  {
    name: "content",
    path: "",
    component: () => import("/vercel/path0/base/pages/content/index.vue")
  },
  {
    name: "content-menu-items",
    path: "menu-items",
    component: () => import("/vercel/path0/base/pages/content/menu-items.vue")
  },
  {
    name: "content-file-upload",
    path: "file-upload",
    component: () => import("/vercel/path0/base/pages/content/file-upload.vue")
  },
  {
    name: "content-stock-images",
    path: "stock-images",
    component: () => import("/vercel/path0/base/pages/content/stock-images.vue")
  }
]
  },
  {
    name: "slug",
    path: "/:slug?",
    meta: _91_91slug_93_93QsK4XG8M4jXI1MXEDlD7KmTbHy2GYd3IBbZ4yPxAa7YMeta || {},
    component: () => import("/vercel/path0/base/pages/[[slug]].vue")
  },
  {
    name: "partners",
    path: "/partners",
    meta: partnersfNjqDY_45glohiyHaI45rG4Wr_vGNwESn4uIMb9GYoXOUMeta || {},
    component: () => import("/vercel/path0/volunteerly/pages/partners.vue")
  },
  {
    name: "test-api",
    path: "/test/api",
    meta: apiSOdkRnbISCaAkoRAqOfKP32OwBIPnyaGjuCwC9uDM0cMeta || {},
    component: () => import("/vercel/path0/volunteerly/pages/test/api.vue")
  },
  {
    name: "test-auth",
    path: "/test/auth",
    meta: authM6xkMaERq0O0C1h9tZiOQcluo_45wwE4pXcHhyjBKq_iQMeta || {},
    component: () => import("/vercel/path0/base/pages/test/auth.vue")
  },
  {
    name: "test-dupe",
    path: "/test/dupe",
    meta: dupeesfwdPNhguiksYpsbsUNSORkFpYL30oLLcYPc9ZH8uwMeta || {},
    component: () => import("/vercel/path0/base/pages/test/dupe.vue")
  },
  {
    name: "test-form",
    path: "/test/form",
    meta: form2Et0Ex1WDnn1LQOzNPPcUaGcF7_45LiF2eHaPWUbkrjwIMeta || {},
    component: () => import("/vercel/path0/base/pages/test/form.vue")
  },
  {
    name: "test-user",
    path: "/test/user",
    meta: usergP1j2ugkOOTjfIOTEE84Z4_I0BzGtfGwgtoQkc7whosMeta || {},
    component: () => import("/vercel/path0/base/pages/test/user.vue")
  },
  {
    name: "uitloggen",
    path: "/uitloggen",
    component: () => import("/vercel/path0/base/pages/uitloggen.vue")
  },
  {
    name: "users-add",
    path: "/users/add",
    meta: addtCvDip_45gr_RHXHHnVup4604_45OGSrQgt9rSwO0VvjptcMeta || {},
    component: () => import("/vercel/path0/base/pages/users/add.vue")
  },
  {
    name: "auth-reset",
    path: "/auth/reset",
    meta: reset78Ka2XQeSD_Mqmo_45L0NKLVjPtxjgEJykMea_cq2GcswMeta || {},
    component: () => import("/vercel/path0/base/pages/auth/reset.vue")
  },
  {
    name: "auth-token",
    path: "/auth/token",
    component: () => import("/vercel/path0/base/pages/auth/token.vue")
  },
  {
    name: "test-colors",
    path: "/test/colors",
    component: () => import("/vercel/path0/base/pages/test/colors.vue")
  },
  {
    name: "test-sentry",
    path: "/test/sentry",
    component: () => import("/vercel/path0/base/pages/test/sentry.vue")
  },
  {
    name: "test-tiptap",
    path: "/test/tiptap",
    meta: tiptapZF_z2fZEAOqMye0sS6vh8NgZkNfnQaw3_45NLG7_aUKuYMeta || {},
    component: () => import("/vercel/path0/base/pages/test/tiptap.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/vercel/path0/base/pages/users/index.vue")
  },
  {
    name: "auth-login-1",
    path: "/auth/login-1",
    meta: login_451OezAPgOU8OgIsqyIsj0rIcnrmiegfAWEU7y5OhX0Xy4Meta || {},
    component: () => import("/vercel/path0/base/pages/auth/login-1.vue")
  },
  {
    name: "auth-recover",
    path: "/auth/recover",
    meta: recoverKAswSXY0F54QD5SJTFd1JgQTo9zF7PIqylCuE7vRqdoMeta || {},
    component: () => import("/vercel/path0/base/pages/auth/recover.vue")
  },
  {
    name: instellingen5uDB5fDtgAITgRtmA5VPULm2bUfJOS_45EqOO31j3fld8Meta?.name,
    path: "/instellingen",
    component: () => import("/vercel/path0/volunteerly/pages/instellingen.vue"),
    children: [
  {
    name: "instellingen",
    path: "",
    component: () => import("/vercel/path0/volunteerly/pages/instellingen/index.vue")
  },
  {
    name: "instellingen-design",
    path: "design",
    component: () => import("/vercel/path0/volunteerly/pages/instellingen/design.vue")
  },
  {
    name: "instellingen-footer",
    path: "footer",
    component: () => import("/vercel/path0/volunteerly/pages/instellingen/footer.vue")
  },
  {
    name: "instellingen-organisatie",
    path: "organisatie",
    component: () => import("/vercel/path0/base/pages/instellingen/organisatie.vue")
  },
  {
    name: "instellingen-contact-person",
    path: "contact-person",
    component: () => import("/vercel/path0/volunteerly/pages/instellingen/contact-person.vue")
  }
]
  },
  {
    name: profile_45editfJHqxD9pjopzAWMddQFTUyFlSqGdMh9SStSTdLx5xFsMeta?.name,
    path: "/profile-edit",
    component: () => import("/vercel/path0/base/pages/profile-edit.vue"),
    children: [
  {
    name: "profile-edit-email",
    path: "email",
    component: () => import("/vercel/path0/base/pages/profile-edit/email.vue")
  },
  {
    name: "profile-edit",
    path: "",
    component: () => import("/vercel/path0/volunteerly/pages/profile-edit/index.vue")
  },
  {
    name: "profile-edit-settings",
    path: "settings",
    meta: settings9KYisyRo2PMIyO3Jp18T_45xk0BRll6i8KO0JK1In1g_45sMeta || {},
    component: () => import("/vercel/path0/base/pages/profile-edit/settings.vue")
  },
  {
    name: "profile-edit-periodieke-mail",
    path: "periodieke-mail",
    component: () => import("/vercel/path0/base/pages/profile-edit/periodieke-mail.vue")
  }
]
  },
  {
    name: "signup",
    path: "/signup",
    meta: indexAHmqB2DQypbdtg0N67Fmn1x5URPgRY5d_45Vs_45iIpOcYgMeta || {},
    component: () => import("/vercel/path0/volunteerly/pages/signup/index.vue")
  },
  {
    name: "test-toaster",
    path: "/test/toaster",
    component: () => import("/vercel/path0/base/pages/test/toaster.vue")
  },
  {
    name: "account-roles",
    path: "/account/roles",
    component: () => import("/vercel/path0/base/pages/account/roles.vue")
  },
  {
    name: "confirm",
    path: "/confirm",
    meta: indexJ542y_0elABrCYz1UPobUSRF8cO5KIJnqcqThFfj9YgMeta || {},
    component: () => import("/vercel/path0/base/pages/confirm/index.vue")
  },
  {
    name: "profiel",
    path: "/profiel",
    component: () => import("/vercel/path0/volunteerly/pages/profiel/index.vue")
  },
  {
    name: "vacancies-add",
    path: "/vacancies/add",
    component: () => import("/vercel/path0/volunteerly/pages/vacancies/add.vue")
  },
  {
    name: "signup-success",
    path: "/signup/success",
    meta: successNLioIIDxkpBSfXdTCyoBKz_Gha1STEh1Ze8qdotLl2YMeta || {},
    component: () => import("/vercel/path0/volunteerly/pages/signup/success.vue")
  },
  {
    name: "test-step-form",
    path: "/test/step-form",
    component: () => import("/vercel/path0/base/pages/test/step-form.vue")
  },
  {
    name: "analytics",
    path: "/analytics",
    meta: index4G1ApQYCnbWmPdCqsKuhBxNOGqXd9GCpl1HjPahe9ucMeta || {},
    component: () => import("/vercel/path0/base/pages/analytics/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/vercel/path0/volunteerly/pages/dashboard/index.vue")
  },
  {
    name: "een-op-een-hulp",
    path: "/een-op-een-hulp",
    meta: een_45op_45een_45hulpslWHx8s3ngAGg1PeLzkuL_vNKa0oD65075CKPIQozu4Meta || {},
    component: () => import("/vercel/path0/volunteerly/pages/een-op-een-hulp.vue")
  },
  {
    name: "forms-token",
    path: "/forms/:token?",
    meta: _91_91token_93_93G_fI772El8Xn6zqIzr4sJkhuvp_QvgJUfatVtOy9yb4Meta || {},
    component: () => import("/vercel/path0/base/pages/forms/[[token]].vue")
  },
  {
    name: "gelderse-handen",
    path: "/gelderse-handen",
    meta: gelderse_45handenuCb6tdtLV3kfR4cR6UZe5MLPyjqh0ueACeicPIH5f5wMeta || {},
    component: () => import("/vercel/path0/volunteerly/pages/gelderse-handen.vue")
  },
  {
    name: "nieuws-slug",
    path: "/nieuws/:slug?",
    meta: _91_91slug_93_9347z5XE5NpXFKxdK0utfxGJTDXP3zggcWqBpUSy9VcpwMeta || {},
    component: () => import("/vercel/path0/base/pages/nieuws/[[slug]].vue")
  },
  {
    name: "test-datepicker",
    path: "/test/datepicker",
    meta: datepickerZ9Uc62dayGHTsUBHzNt0voknTbZhe3CWBn9nj9du43MMeta || {},
    component: () => import("/vercel/path0/base/pages/test/datepicker.vue")
  },
  {
    name: "test-dollar-api",
    path: "/test/dollar-api",
    component: () => import("/vercel/path0/base/pages/test/dollar-api.vue")
  },
  {
    name: "test-user-store",
    path: "/test/user-store",
    component: () => import("/vercel/path0/base/pages/test/user-store.vue")
  },
  {
    name: "users-id-edit",
    path: "/users/:id()/edit",
    component: () => import("/vercel/path0/base/pages/users/[id]/edit.vue")
  },
  {
    name: "vacancies",
    path: "/vacancies",
    component: () => import("/vercel/path0/volunteerly/pages/vacancies/index.vue")
  },
  {
    name: "workshops",
    path: "/workshops",
    component: () => import("/vercel/path0/volunteerly/pages/workshops/index.vue")
  },
  {
    name: "contactformulier",
    path: "/contactformulier",
    component: () => import("/vercel/path0/base/pages/contactformulier.vue")
  },
  {
    name: "form_builder-new",
    path: "/form_builder/new",
    component: () => import("/vercel/path0/base/pages/form_builder/new.vue")
  },
  {
    name: "test-formbuilder",
    path: "/test/formbuilder",
    component: () => import("/vercel/path0/base/pages/test/formbuilder.vue")
  },
  {
    name: "test-step-form-2",
    path: "/test/step-form-2",
    component: () => import("/vercel/path0/base/pages/test/step-form-2.vue")
  },
  {
    name: "users-id",
    path: "/users/:id()",
    component: () => import("/vercel/path0/base/pages/users/[id]/index.vue")
  },
  {
    name: "admin-data-viewer",
    path: "/admin/data-viewer",
    component: () => import("/vercel/path0/base/pages/admin/data-viewer.vue")
  },
  {
    name: "analytics-index-2",
    path: "/analytics/index-2",
    component: () => import("/vercel/path0/base/pages/analytics/index-2.vue")
  },
  {
    name: "organizations-add",
    path: "/organizations/add",
    component: () => import("/vercel/path0/volunteerly/pages/organizations/add.vue")
  },
  {
    name: "test-server-error",
    path: "/test/server-error",
    component: () => import("/vercel/path0/base/pages/test/server-error.vue")
  },
  {
    name: "applications",
    path: "/applications",
    component: () => import("/vercel/path0/volunteerly/pages/applications/index.vue")
  },
  {
    name: "form_builder",
    path: "/form_builder",
    component: () => import("/vercel/path0/base/pages/form_builder/index.vue")
  },
  {
    name: "notificaties",
    path: "/notificaties",
    component: () => import("/vercel/path0/base/pages/notificaties/index.vue")
  },
  {
    name: "profiel-verwijderd",
    path: "/profiel/verwijderd",
    component: () => import("/vercel/path0/volunteerly/pages/profiel/verwijderd.vue")
  },
  {
    name: "sociale-kaart-id",
    path: "/sociale-kaart/:id()",
    meta: _91id_93MtUYzBLXATGxg6ubBtRh19KuMXYY_cmHOQ7PTyKxX40Meta || {},
    component: () => import("/vercel/path0/volunteerly/pages/sociale-kaart/[id].vue")
  },
  {
    name: "account-verwijderen",
    path: "/account/verwijderen",
    meta: verwijderenkam4Fk_45d9q24mjZqvJYiU4h3LUZkMlI6y_ThjDOC4RQMeta || {},
    component: () => import("/vercel/path0/base/pages/account/verwijderen.vue")
  },
  {
    name: "conversations",
    path: "/conversations",
    component: () => import("/vercel/path0/volunteerly/pages/conversations/index.vue")
  },
  {
    name: "organizations",
    path: "/organizations",
    component: () => import("/vercel/path0/volunteerly/pages/organizations/index.vue")
  },
  {
    name: "sociale-kaart",
    path: "/sociale-kaart",
    meta: indexdb2QOxwmCd1ShI9dREFbgLGVS15MT_45R7sQ3GsRbZJY8Meta || {},
    component: () => import("/vercel/path0/volunteerly/pages/sociale-kaart/index.vue")
  },
  {
    name: "users-id-add_role",
    path: "/users/:id()/add_role",
    component: () => import("/vercel/path0/base/pages/users/[id]/add_role.vue")
  },
  {
    name: "vacancies-id-edit",
    path: "/vacancies/:id()/edit",
    component: () => import("/vercel/path0/volunteerly/pages/vacancies/[id]/edit.vue")
  },
  {
    name: "vacancies-bulk-edit",
    path: "/vacancies/bulk-edit",
    component: () => import("/vercel/path0/volunteerly/pages/vacancies/bulk-edit.vue")
  },
  {
    name: "vacancies-id",
    path: "/vacancies/:id()",
    meta: index4_acO5hAi_45BYkhCgIWkYU61nNHKdqUxa3aZIwQtcLOsMeta || {},
    component: () => import("/vercel/path0/volunteerly/pages/vacancies/[id]/index.vue")
  },
  {
    name: "organizations-approve",
    path: "/organizations/approve",
    component: () => import("/vercel/path0/volunteerly/pages/organizations/approve.vue")
  },
  {
    name: "profile-replies",
    path: "/profile-replies",
    component: () => import("/vercel/path0/volunteerly/pages/profile-replies/index.vue")
  },
  {
    name: "volunteerly-changelog",
    path: "/volunteerly/changelog",
    meta: changelogL36YcMCe59TaL6l90GrQqh_45294yxcgjb_454HXoeCUjb4Meta || {},
    component: () => import("/vercel/path0/volunteerly/pages/volunteerly/changelog.vue")
  },
  {
    name: "form_builder-id-edit",
    path: "/form_builder/:id()/edit",
    component: () => import("/vercel/path0/base/pages/form_builder/[id]/edit.vue")
  },
  {
    name: "vacancies-search",
    path: "/vacancies/search",
    meta: indexnQj3kTeDJKm1KVH1SgUwZuEww_45J4Dy9b4lwMMHwFIOMMeta || {},
    component: () => import("/vercel/path0/volunteerly/pages/vacancies/search/index.vue")
  },
  {
    name: "applications-id",
    path: "/applications/:id()",
    component: () => import("/vercel/path0/volunteerly/pages/applications/[id]/index.vue")
  },
  {
    name: "form_builder-id",
    path: "/form_builder/:id()",
    component: () => import("/vercel/path0/base/pages/form_builder/[id]/index.vue")
  },
  {
    name: "organizations-id-edit",
    path: "/organizations/:id()/edit",
    component: () => import("/vercel/path0/volunteerly/pages/organizations/[id]/edit.vue")
  },
  {
    name: "organizations-id-move",
    path: "/organizations/:id()/move",
    component: () => import("/vercel/path0/volunteerly/pages/organizations/[id]/move.vue")
  },
  {
    name: "vrijwilligerspool",
    path: "/vrijwilligerspool",
    component: () => import("/vercel/path0/volunteerly/pages/vrijwilligerspool/index.vue")
  },
  {
    name: "organizations-id",
    path: "/organizations/:id()",
    meta: indexN9mA75OPwKgGV7D4Y4t6E5PEpLrJggpxCiuUWWo39PYMeta || {},
    component: () => import("/vercel/path0/volunteerly/pages/organizations/[id]/index.vue")
  },
  {
    name: "form_builder-id-preview",
    path: "/form_builder/:id()/preview",
    component: () => import("/vercel/path0/base/pages/form_builder/[id]/preview.vue")
  },
  {
    name: "activiteitenkalender",
    path: "/activiteitenkalender",
    meta: index0dIVMUrneLyWt378e_h0FUBtX8UuVUaDo4x2SycsFqMMeta || {},
    component: () => import("/vercel/path0/volunteerly/pages/activiteitenkalender/index.vue")
  },
  {
    name: "organizations-signup",
    path: "/organizations/signup",
    meta: index0HhoILaZz6o2rG3kufdTemM1_45wbGDXqv2JtpDJnuQ28Meta || {},
    component: () => import("/vercel/path0/volunteerly/pages/organizations/signup/index.vue")
  },
  {
    name: "notification_templates",
    path: "/notification_templates",
    component: () => import("/vercel/path0/base/pages/notification_templates/index.vue")
  },
  {
    name: "organizations-signup-success",
    path: "/organizations/signup/success",
    meta: successXVwnruZ10l93HoRJl_45KH_QfUD4ewe7RE0GCQQIFBvDcMeta || {},
    component: () => import("/vercel/path0/volunteerly/pages/organizations/signup/success.vue")
  },
  {
    name: "activiteitenkalender-overzicht",
    path: "/activiteitenkalender/overzicht",
    component: () => import("/vercel/path0/volunteerly/pages/activiteitenkalender/overzicht.vue")
  },
  {
    name: "notification_templates-id-edit",
    path: "/notification_templates/:id()/edit",
    component: () => import("/vercel/path0/base/pages/notification_templates/[id]/edit.vue")
  },
  {
    name: "form_builder-id-submissions-submissionId",
    path: "/form_builder/:id()/submissions/:submissionId()",
    component: () => import("/vercel/path0/base/pages/form_builder/[id]/submissions/[submissionId].vue")
  }
]